export const isLocal = () => {
    return window.location.host.indexOf("local") != -1;
};
export const isColl = () => {
    return window.location.host.indexOf("-col.") != -1;
};
export const isProd = () => {
    return window.location.host.indexOf("compass.it") != -1 || window.location.host.indexOf("compassquinto.it") != -1;
};

const getUserAgent = () => {
    return (navigator.userAgentData.platform ?? navigator.platform).toLowerCase();
};
export const isIOS = () => {
    return /iphone/gi.test(getUserAgent()) || /ipad/gi.test(getUserAgent());
};
export const isAndroid = () => {
    return /android/gi.test(getUserAgent());
};

export const isDesktop = () => {
    return window.screen && (window.screen.width >= 1280 || window.screen.availWidth >= 1280);
};
